import useDebouncedCallback from 'hooks/useDebouncedCallback';
import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import Typography from '@material-ui/core/Typography';
import GenericTable from '../../Components/GenericTable';
import { Paths } from '../../Routes/routePaths'
import { DeploymentServices } from '../../Services/DeploymentServices';
import { Pagination } from '@material-ui/lab';
import OutlinedButton from 'Components/OutlinedButton';
import SearchBoxInput from 'Components/SearchBoxInput';
import { useHistory } from 'react-router';
import commonStyles from 'theme/commonStyles';

const deploymentServices = new DeploymentServices();

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        width: '100%',
        boxSizing: 'border-box',
        [theme.breakpoints.up('sm')]: {
            minHeight: 180,
        },
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: '100%',
        maxWidth: 174,
        height: 'auto',
        maxHeight: 132,
        paddingTop: 17,
        marginTop: 16,
        marginLeft: 0,
        borderRadius: 5,
        objectFit: 'contain',
        [theme.breakpoints.up('sm')]: {
            marginTop: 25,
            marginLeft: 20,
        },
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    cardTitle: {
        color: "#808080"
    },
    cardSubTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: "#3D7DDD",
    },
    pageTitle: {
        marginBottom: theme.spacing(3),
        wordBreak: 'break-word',
    },
    searchBox: {
        border: "1px solid #808080",
        borderRadius: 25,
        padding: '7px 15px'
    }
}));

const columns = [
    { label: "Name", key: 'name' },
    { label: "Description", key: 'description' },
    { label: "Repository", key: 'repository' },
    { label: "Action", key: "action", actions: ["edit"] }
];

const Deployments = () => {

    useStyles();
    const history = useHistory();
    const commonClasses = commonStyles();

    const [filterState, setFilterState] = React.useState({ page: 1, search: "" });
    const [deploymentList, setDeploymentList] = React.useState([]);
    const [pagination, setPagination] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        getAllCustomer({ page: 1, search: "" });
    }, []);

    const getAllCustomer = async (queryData) => {
        setLoading(true);
        let query = `search=${encodeURIComponent(queryData.search)}&page=${queryData.page}`;
        const deploymentList = await deploymentServices.getAllDeployment(`services/deploymentlist?${query}`);
        if (deploymentList && deploymentList.results) {
            setDeploymentList(deploymentList.results);
            setPagination(deploymentList.pagination);
        }
        setLoading(false);
    };

    const searchLater = useDebouncedCallback(query => {
        setLoading(true);
        getAllCustomer(query);
    });

    const handlePageChange = (evt, page) => {
        searchLater.cancel();
        setFilterState({ ...filterState, page });
        return getAllCustomer({ ...filterState, page });
    };

    const handleSearch = e => {
        e.preventDefault();
        searchLater.cancel();
        setFilterState({ ...filterState, page: 1 });
        setLoading(true);
        return getAllCustomer({ ...filterState, page: 1 });
    };

    const handleItemClick = (row) => {
        if (!row) return null;
        history.push(Paths.createDeployment + '/' + row.uuid);
    }

    const handleCreateNew = () => {
        history.push(Paths.createDeployment);
    }

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <Typography variant="h4" className={commonClasses.pageTitle}>Deployments</Typography>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item xs={12} sm={6} md={4}>
                            <SearchBoxInput 
                                placeholder="Search deployments"
                                value={filterState.search} 
                                handleChange={(evt) => {
                                    const next = { ...filterState, search: evt.target.value, page: 1 };
                                    setFilterState(next);
                                    searchLater(next);
                                }}
                                handleSearch={handleSearch} 
                            />
                        </Grid>
                        <Grid item xs={12} sm="auto">
                            <OutlinedButton 
                                title={"Create Deployment"} 
                                handleClick={handleCreateNew} 
                                align={'right'} 
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: 20 }}>
                        <GenericTable
                            columns={columns}
                            loading={loading}
                            handleItemClick={handleItemClick}
                            list={deploymentList}
                        />
                    </Grid>
                    <Grid container style={{ marginTop: 22 }} >
                        {pagination &&
                            <Pagination
                                page={filterState.page}
                                onChange={handlePageChange}
                                className={commonClasses.pagination}
                                count={parseInt(Math.ceil(pagination.total_entries / pagination.end_index))}
                                variant="outlined"
                                shape="rounded"
                                siblingCount={0}
                            />}
                    </Grid>
                </div>
            </main>
        </Layout>
    );
}

export default Deployments;
